module.exports = __webpack_public_path__ + "img/login-left.0f3d68fc.png";